const choices = {
    securityProgress: 'Une progression sécuritaire en contrepartie d\'un rendement limité et d\'une prise de risque très réduite',
    moderateProgress: 'Une progression modérée avec une prise de risque modérée',
    highProgress: 'Une progression plus élevée en moyenne, moins régulière avec un risque de perte plus important',
    highProgressHighRisk: 'Une forte progression en moyenne en contrepartie d\'un risque élevé',
};

export default choices;
